<template>
  <div>
    <empty-page image="nowifi" v-if="error.statusCode === -1">
      <h1>{{ $t('networkErrorTitle') }}</h1>
      <p>{{ $t('networkErrorText') }}</p>
      <ck-footer :title="$t('reloadPage')" @click.native="reloadPage" />
    </empty-page>
    <empty-page
      image="custom"
      v-else-if="
        error.statusCode === 502 &&
          error.message &&
          error.message.startsWith('energy')
      "
    >
      <ck-icon
        slot="image"
        name="ico-custom-budget-control-error-128px"
        size="128px"
      />
      <template v-if="error.message === 'energy-pv-optimisation'">
        <ck-icon
          slot="image"
          name="ico-custom-budget-control-error-128px"
          size="128px"
        />
        <h1>{{ $t('errorEnergyOptimisationTitle') }}</h1>
        <p v-html="$t('errorEnergyOptimisationText')"></p>
      </template>
      <template v-else-if="error.message === 'energy-pv-optimisation-dhw'">
        <ck-icon
          slot="image"
          name="ico-custom-budget-control-error-128px"
          size="128px"
        />
        <h1>{{ $t('errorEnergyOptimisationDhwTitle') }}</h1>
        <p v-html="$t('errorEnergyOptimisationDhwText')"></p>
      </template>
      <template v-else>
        <h1>{{ $t('errorBudgetControlTitle') }}</h1>
        <p v-html="$t('errorBudgetControlText')"></p>
      </template>
      <ck-footer :title="$t('quit')" @click.native="goToEnergy" />
    </empty-page>
    <empty-page image="nowifi" v-else>
      <h1>{{ $t('generalErrorTitle') }}</h1>
      <p>{{ $t('generalErrorText') }}</p>
      <ck-footer :title="$t('back')" @click.native="goToRoot" />
    </empty-page>
  </div>
</template>

<script>
import '@/plugins/global-css'
import CkFooter from '@/components/kit/CkFooter'
import EmptyPage from '@/components/shared-layout/EmptyPage'
export default {
  components: {
    CkFooter,
    EmptyPage
  },
  props: {
    error: Object
  },
  created() {
    this.$store.commit('setErrorPage', true)
  },
  beforeDestroy() {
    this.$store.commit('setErrorPage', false)
  },
  methods: {
    goToEnergy() {
      if (
        this.error?.statusCode === 502 &&
        this.error?.message?.startsWith('energy')
      ) {
        const language = this.$storage.getUniversal('language') || 'en'
        this.$router.push({
          name: 'launcher',
          query: { status: 'energy', preferred_language: language }
        })
      } else {
        this.$router.push({
          name: 'energy'
        })
      }
    },
    reloadPage() {
      this.$router.go()
    },
    goToRoot() {
      const language = this.$storage.getUniversal('language') || 'en'
      if (
        this.$store.state.pageHistory &&
        this.$store.state.pageHistory.length &&
        this.$store.state.pageHistory[
          this.$store.state.pageHistory.length - 1
        ].includes('energy')
      ) {
        this.$router.push({
          name: 'launcher',
          query: { status: 'energy', preferred_language: language }
        })
      } else {
        this.$router.push({
          name: 'launcher',
          query: { status: 'overview', preferred_language: language }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';
</style>
